module.exports = __webpack_public_path__ + "static/Sonik-Logo-50911662de6c3b2b9b85a7a4daf7c414.gif";